const timers: Record<string, NodeJS.Timeout> = {};

// Unflap will smooth over flaky intermediate states by running
// `action` on a delay if shouldDelay is true, and immediately
// otherwise.
//
// For example, if you have a component that will become read-only if
// you lose a server connection, this could be used to delay the
// read-only transition for a few seconds in case it recovers.
export function unflap(name, action, shouldDelay, time) {
  const act = () => {
    if (timers[name]) {
      clearTimeout(timers[name]);
    }

    delete timers[name];
    action();
  };

  if (shouldDelay) {
    if (!timers[name]) {
      timers[name] = setTimeout(act, time);
    }
  } else {
    act();
  }
}

export function clearUnflap(name) {
  if (timers[name]) {
    clearTimeout(timers[name]);
    delete timers[name];
  }
}
